<template>
  <shared-provide-variation :variation="variation" :fromModule="fromModule" :toModule="toModule" @change="emitToParent">
    <div class="divider"><span>Atributos</span></div>

    <div class="l-row">
      <form-group v-if="Object.keys(variation.attributes).indexOf('color') !== -1" :label="$t(`color.label`)" :columns="3" :error="getError('attributes.color', variation.sku)" :required="false">
        <input class="form-input" type="text" v-model="variation.attributes['color']" :disabled="disabledInputs()">
      </form-group>

      <form-group v-if="Object.keys(variation.attributes).indexOf('voltage') !== -1" :label="$t(`voltage.label`)" :columns="3" :error="getError('attributes.voltage', variation.sku)" :required="false">
        <input class="form-input" type="text" v-model="variation.attributes['voltage']" :disabled="disabledInputs()">
      </form-group>

      <form-group v-if="Object.keys(variation.attributes).indexOf('size') !== -1" :label="$t(`size.label`)" :columns="3" :error="getError('attributes.size', variation.sku)" :required="false">
        <input class="form-input" type="text" v-model="variation.attributes['size']" :disabled="disabledInputs()">
      </form-group>

      <form-group v-if="Object.keys(variation.attributes).indexOf('flavor') !== -1" :label="$t(`flavor.label`)" :columns="3" :error="getError('attributes.flavor', variation.sku)" :required="false">
        <input class="form-input" type="text" v-model="variation.attributes['flavor']" :disabled="disabledInputs()">
      </form-group>
    </div>
  </shared-provide-variation>
</template>

<script>
  import { mapGetters } from 'vuex'
  import SharedProvideVariation from '@/components/marketplace/shared/provide/Variation'
  import FormGroup from '@/components/template/FormGroup'

  export default {
    props: {
      variation: {
        type: Object,
        required: true
      },
      fromModule: {
        type: Object,
        required: true
      },
      toModule: {
        type: Object,
        required: true
      }
    },
    methods: {
      disabledInputs () {
        return this.variation.status === 'sent' || this.variation.status === 'error'
      },
      emitToParent (value) {
        this.$emit('change', value)
      }
    },
    created () {
      this.variation.attributes.crossDocking = this.variation.crossDocking ? this.variation.crossDocking : 0
    },
    computed: {
      ...mapGetters('errors', [
        'getError'
      ])
    },
    components: {
      SharedProvideVariation,
      FormGroup
    }
  }
</script>



// WEBPACK FOOTER //
// Variation.vue?2f9b8ef9